import React from 'react';
import { Route } from 'mobx-router';


//components
import MyBets from '../components/appComponents/MyBets'
import Leaderboard from '../components/appComponents/Leaderboard'
import CustomBets from '../components/appComponents/CustomBets'
import Oracles from '../components/appComponents/Oracles'
import FeaturedEvents from '../components/appComponents/FeaturedEvents'
import SingleEvent from '../components/appComponents/SingleEvent'
import EventCategories from '../components/appComponents/EventCategories'
import Leagues from '../components/appComponents/Leagues'
import NotFoundPage from '../components/appComponents/NotFoundPage'
import ExpiredEvents from '../components/appComponents/events/ExpiredEvents';
import AdminPanel from '../components/appComponents/admin/AdminPanel';
import MyStats from '../components/MyStats.js';
import Watchlist from '../components/appComponents/Watchlist';
import Team from '../components/appComponents/Team';
import TakeBetModal from "../components/modals/TakeBetModal";
import MyBetsPage from '../components/appComponents/MyBetsPage';
import Casino from '../components/appComponents/Casino';

const NavViews = {
  home: new Route({
    path: '/',
    component: <FeaturedEvents />
  }),
  myBets: new Route({
    path: '/mybets',
    component: <MyBetsPage />
  }),
  casino: new Route({
    path: '/casino',
    component: <Casino />
  }),
  myStats: new Route({
    path: '/mystats',
    component: <MyStats />
  }),
  expiredEvents: new Route({
    path: '/expired_events',
    component: <ExpiredEvents />
  }),
  leaderBoard: new Route({
    path: '/leaderboard',
    component: <Leaderboard />
  }),
  watchlist: new Route({
    path: '/watchlist',
    component: <Watchlist />
  }),
  singleEvent: new Route({
    path: '/event/:eventID',
    component: <SingleEvent />,
    onEnter: (route, params, store) => {
      console.log(`entering event with params`, params);
    }
  }),
  takeBet: new Route({
    path: '/take_bet/:betId',
    component: <TakeBetModal />,
    onEnter: (route, params, store) => {

      console.log(`entering Take Bet with params`, params);
    }
  }),
  team: new Route({
    path: '/team/:teamID',
    component: <Team />,
    onEnter: (route, params, store) => {
      console.log(`entering event with params`, params);
    }
  }),
  categories: new Route({
    path: '/categories/:categoryId',
    component: <EventCategories />,
    onEnter: (route, params, store) => {
      console.log(`entering category with params`, params);
    }
  }),
  leagues: new Route({
    path: '/leagues/:leagueId',
    component: <Leagues />,
    onEnter: (route, params, store) => {
      console.log(`entering league with params`, params);
    }
  }),
  customBets: new Route({
    path: '/custombets',
    component: <CustomBets />
  }),
  oracles: new Route({
    path: '/oracles',
    component: <Oracles />
  }),
  admin: new Route({
    path: '/admin',
    component: <AdminPanel />
  }),
};
export default NavViews;


// WEBPACK FOOTER //
// ./src/stores/NavViews.js